module.exports = flarum.extensions['justoverclock-users-map-location'];